import {
  Board,
  Column,
  Panel,
  PanelDivider,
  PanelHeading,
} from '@gamma/ui/layout';
import { ErrorBoundary } from '@gamma/ui/overlay';
import { GraphQLReqStatus } from '@gamma/ui/progress';
import { i18n } from '../../../../../shared/localization';
import { useDescribeIdentityProvider } from '../../../queries';

import { SAMLSingleSignOn } from './SAMLSingleSignOn';
import { DomainsList } from './DomainsList/DomainsList';

const { title } = i18n.pages.access;

export const Access = () => {
  const { data, loading, error } = useDescribeIdentityProvider({
    fetchPolicy: 'cache-and-network',
  });

  if (loading || error) {
    return (
      <ErrorBoundary page="Access" styleClass="main">
        <Panel>
          <GraphQLReqStatus loading={loading} error={error} />
        </Panel>
      </ErrorBoundary>
    );
  }

  const {
    describeIdentityProvider: { is_sso_enabled: isSSOEnabled },
  } = data;

  return (
    <Board data-testid="access-page">
      <Column>
        <Panel marginY={2} height="auto">
          <PanelHeading>{title}</PanelHeading>
          <PanelDivider />
          <SAMLSingleSignOn data={data} />
        </Panel>
        {isSSOEnabled && <DomainsList />}
      </Column>
    </Board>
  );
};
